import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'core_collections-product_based_collection_tile-view';
/**
 * View all collections impression
 */
export function trackCoreCollectionsProductBasedCollectionTileView(productBasedCollectionToken, customParameterToken, brandPromoCollectionToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            productBasedCollectionToken,
            customParameterToken,
            brandPromoCollectionToken,
        },
    });
}
